import { LOGOUT } from 'modules/auth/actions/logout';
import createReducer from 'shared/utils/createReducer';
import { SET_USER_IDS } from 'modules/queues/common/actions/resubscribeUserAndAvailabilityUpdates';

const defaultState = { userIds: [] };


export default createReducer(defaultState, {
  [SET_USER_IDS]: (state, { payload: { userIds } }) => ({
    ...state,
    userIds,
  }),


  [LOGOUT.failure]: () => defaultState,
  [LOGOUT.success]: () => defaultState,
});